import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import "./PeFcsfiRwProductCategories.css";

export type ProductGroupsComparison = {
  noChanges: boolean;
  changesRequired: boolean;
  notApplicable: boolean;
};

interface PeFcsfiRwProductCategoriesProps {
  setFormData:any;
  formData:any;
}

const productGroupsComparisonOptions = [
  {
    label: "--None--",
    value: "null",
  },
  {
    label: "Organization’s product categories are accurately reflected in the PEFC database, no changes.",
    value: "Matched",
  },
  {
    label: "Changes required, see “SECTION 2: CONFIRMATION OF CHANGES” (above) with list of changes.",
    value: "Changes Required, See section 2",
  },
  {
    label: "Evaluation audit – confirmation of the PEFC database is not applicable.",
    value: "Not Applicable, evaluation Audit",
  },
];

const PeFcsfiRwProductCategories: React.FC<PeFcsfiRwProductCategoriesProps> = ({
  formData,
  setFormData,
}) => {
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      Product_List_Comparison_SCS_PEFC__c: e.target.value === "null" ? null : e.target.value,
    });
  };
  
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      PEFC_SFI_RW_Product_Categories__c: e.target.checked,
    });
  };
  

  return (
    <>
      <div className="product-categories-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          PEFC/SFI/RW Product Categories
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="na-checkbox"
          label="N/A"
          className="na-checkbox"
          checked={formData.PEFC_SFI_RW_Product_Categories__c}
          onChange={handleCheckboxChange}
        />
      </div>

      <div className="p-4">
        <Row>
          <Col>
            <Form.Label>
              1. Check here to confirm that the organization’s listing on the PEFC database has been compared to the organization’s current list of product categories.
            </Form.Label>
            <div>
              {productGroupsComparisonOptions.map((option) => (
                <Form.Check key={option.value}>
                  <Form.Check.Input
                    type="radio"
                    name="Product_List_Comparison_SCS_PEFC__c"
                    value={option.value ?? "null"}
                    checked={
                      String(formData.Product_List_Comparison_SCS_PEFC__c) === String(option.value)
                    }
                    onChange={handleRadioChange}
                    className="product-category-check-input"
                  />
                  <Form.Check.Label className="product-categories-label">
                    {option.label}
                  </Form.Check.Label>
                </Form.Check>
              ))}
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label className="mt-2">
              2. The PEFC Product Category List is required as a separate document using the upload section in Annex A.
            </Form.Label>
          </Col>
        </Row>
      </div>
    </>
  );
};


export default PeFcsfiRwProductCategories;
